export const ExperienceData = [
    {
        "jobTitle": "Software Engineer Intern",
        "company": "Apple",
        "date": "Aug 2024 – Jan 2025",
        "bulletPoints": [
            "Designed and implemented microservices using Temporal and Kafka to reconcile 10,000+ mismatched employee records across Workday and Apple systems, reducing discrepancies by 90%.", 
            "Contributed production-level features to an API gateway layer to route downstream requests from Apple to Workday, resulting in API security enhancement, and 15% improvement in the performance.", 
            "Consolidated common application properties into a single configuration file across dev, test, UAT, and production, eliminating redundancy and saving over 124 hours of manual work annually.",
            "Collaborated with functional teams to understand business requirements and translate them into technical designs, enabling solutions that met the organization’s needs."
        ]
    },
    {
        "jobTitle": "Software Engineer Intern",
        "company": "OpenQQuantify",
        "date": "April 2024 – Jul 2024",
        "bulletPoints": [
            "Implemented a data ingestion pipeline using Python and set up backend endpoints with Flask, reducing response time by 30% through response caching with Redis and efficient integration with the OpenAI API.", 
            "Building and maintaining scalable web tools using Python, JavaScript, and modern frameworks.", 
            "Participating in cross-functional projects involving backend services, frontend interfaces, and cloud deployments.",
            "Collaborating with a remote team in an agile environment, engaging in code reviews, testing, and iterative product enhancements."
        ]
    }
]

export const ProjectData = [
    {
        "name": "CleanPR - AI Code Reviewer",
        "github": "https://github.com/fahd209/CleanPR",
        "date": "Jan 2025 – April 2025",
        "description": [

        ],
        "pictures": [
            "Login page", 
            "Chat page",
            "Websocket-Diagram",
            "argoCD",
            "CI/CD-diagram"
        ],
        "skills": [
            'React JS',
            'Spring boot',
            'Spring AI',
            'PostgreSQL'
        ]
    },
    {
        "name": "Easy-shop-E-commerce",
        "github": "https://github.com/fahd209/Easyshop-E-commerce-advanced",
        "date": "June 2024 – July 2024",
        "description": [
            
        ],
        "pictures": [
            "landingPage",
            "Shop",
            "mobileScreen",
            "backEnd-diagram"
        ],
        "skills": [
            'Spring boot', 
            'React JS', 
            'REST API’s', 
            'MySQL', 
            'Docker'  
        ]
    },
     {
        "name": "ChatterLink - chat app",
        "github": "https://github.com/fahd209/ChatterLink",
        "date": "Jan 2025 – April 2025",
        "description": [

        ],
        "pictures": [
            "Login page", 
            "Chat page",
            "Websocket-Diagram",
            "argoCD",
            "CI/CD-diagram"
        ],
        "skills": [
            'Kubernetes',
            'CI/CD',
            'Argo CD',
            'MongoDB',
            'Spring boot',
            'WebSocket',
            'React JS'  
        ]
    }
]

export const skillsData = [
  { name: "Java", icon: "devicon-java-plain" },
  { name: "JavaScript", icon: "devicon-javascript-plain" },
  { name: "Python", icon: "devicon-python-plain" },
  { name: "React.js", icon: "devicon-react-original" },
  { name: "Spring Boot", icon: "devicon-spring-plain" },
  { name: "Spring Web Flux", icon: "devicon-spring-plain" },
  { name: "Apache Kafka", icon: "devicon-apachekafka-original" },
  { name: "ELK Stack", icon: "fas fa-chart-bar" },
  { name: "Kubernetes", icon: "devicon-kubernetes-plain" },
  { name: "Docker", icon: "devicon-docker-plain" },
  { name: "MongoDB", icon: "devicon-mongodb-plain" },
  { name: "MySQL", icon: "devicon-mysql-plain" },
  { name: "NoSQL", icon: "fas fa-database" },
  { name: "Temporal", icon: "fas fa-clock" },
  { name: "REST APIs", icon: "fas fa-plug" }, 
  { name: "OOP", icon: "fas fa-cubes" },
  { name: "JUnit", icon: "fas fa-vial" },
  { name: "GitHub", icon: "devicon-github-original" },
  { name: "Splunk Enterprise", icon: "fas fa-search" },
  { name: "Microservices", icon: "fas fa-layer-group" },
  { name: "HTML", icon: "devicon-html5-plain" },
  { name: "CSS", icon: "devicon-css3-plain" },
  { name: "Backend", icon: "fas fa-server" },
  { name: "Frontend", icon: "fas fa-desktop" },
  { name: "Full-Stack", icon: "fas fa-laptop-code" },
  { name: "Data Structures", icon: "fas fa-sitemap" },
  { name: "Algorithms", icon: "fas fa-cogs" },
  { name: "Agile principles", icon: "fas fa-project-diagram" },
];